import { useChatAccess } from "../../modules/chats/useChatAccess";
import { CHATS_PATH } from "../../paths";
import {
  ChatBubbleOutline,
  AccountBalance,
  DashboardOutlined,
  FindInPageOutlined,
  ManageAccountsOutlined,
  PersonOutline,
  PolylineOutlined,
  TollOutlined,
} from "@mui/icons-material";
import { Box, MenuList, Stack } from "@mui/material";
import { MenuItem, SubMenuItem, useLayout } from "@synota-io/synota-shared-ui";
import {
  CONTRACTS_PATH,
  NODES_BLUE_PENGUIN_PATH,
  NODES_PATH,
  REPORTS_PATH,
  USER_ACCOUNT_PATH,
  USER_PATH,
  USER_SERVICE_CHARGES_PATH,
} from "../../paths";
import { IS_ENABLED_REPORTS } from "../../utils/environment";
import { NodeBalance } from "../../modules/reports/components/NodeBalance";
import { useAuth } from "../../api/auth/useAuth";
import { SearchStateLink } from "./SearchStateLink";
import { useUsers } from "../../api/hooks/useUsers";
import { generatePath } from "react-router-dom";

export const AppMenu = () => {
  const { isAdmin } = useAuth();
  const canViewChats = useChatAccess();
  const { isMobile } = useLayout();
  const { users } = useUsers();

  // const users = a ? [a[0]] : [];

  const userItems =
    users && users[0]
      ? users.length > 1
        ? users.map((user) => (
            <MenuItem
              key={user.uuid}
              to={generatePath(USER_PATH, { id: user.uuid })}
              color="neutral"
              Icon={PersonOutline}
              label={user.public_name || user.email}
              end
              disableLink
            >
              <SubMenuItem
                color="primary"
                to={generatePath(USER_ACCOUNT_PATH, { id: user.uuid })}
                component={SearchStateLink}
              >
                Settings
              </SubMenuItem>
              <SubMenuItem
                color="primary"
                to={generatePath(USER_SERVICE_CHARGES_PATH, { id: user.uuid })}
                component={SearchStateLink}
              >
                Service Charges
              </SubMenuItem>
            </MenuItem>
          ))
        : [
            <MenuItem
              Icon={ManageAccountsOutlined}
              label="Account Settings"
              key="settings"
              color="primary"
              to={generatePath(USER_ACCOUNT_PATH, { id: users[0].uuid })}
              component={SearchStateLink}
            />,
            <MenuItem
              Icon={TollOutlined}
              label="Service Charges"
              key="service-charges"
              color="primary"
              to={generatePath(USER_SERVICE_CHARGES_PATH, { id: users[0].uuid })}
              component={SearchStateLink}
            />,
          ]
      : [];

  const common = (
    <>
      <MenuItem
        color="neutral"
        Icon={DashboardOutlined}
        label="Contracts"
        path={CONTRACTS_PATH}
        component={SearchStateLink}
      />
      {canViewChats && (
        <MenuItem color="neutral" Icon={ChatBubbleOutline} label="Chats" path={CHATS_PATH} />
      )}
    </>
  );

  return (
    <Stack height="100%" flexGrow={1}>
      {isAdmin ? (
        <>
          <MenuList>
            {common}
            {IS_ENABLED_REPORTS && isAdmin && (
              <MenuItem
                color="neutral"
                Icon={FindInPageOutlined}
                label="Reports"
                path={REPORTS_PATH}
              />
            )}
            <MenuItem color="neutral" Icon={PolylineOutlined} label="Nodes" path={NODES_PATH} />
            <MenuItem
              color="neutral"
              Icon={AccountBalance}
              label="BluePenguin"
              path={NODES_BLUE_PENGUIN_PATH}
            />
          </MenuList>
          <Box flexGrow={1} />
          <Stack alignItems="center">{isMobile ? <NodeBalance /> : null}</Stack>
        </>
      ) : (
        <MenuList>
          {common}
          {userItems}
        </MenuList>
      )}
    </Stack>
  );
};
